module.exports = __webpack_public_path__ + "static/img/gongzhonghao.db0fb75.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/gongzhonghao.jpg
// module id = 84QM
// module chunks = 1